export const DEFAULT_TEMPLATE_TYPE = 'default_template';
